import { Injectable } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';

export interface Validation {
  key: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class FormValidatorService {
  validators = {
    Required: [Validators.required],
    EmailValid: [
      Validators.email,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
    ],    
    PasswordMinLength: length => [Validators.minLength(length)],
    PasswordMaxLength: length => [Validators.maxLength(length)]
  };

  //Reset Password Error Message
  errorMsg = {
    required: 'requiredError',
    minLength: 'minLengthError',
    maxLength: 'maxLengthError',
    userName: 'userNameError',
    email: 'userEmailError',
    notMatch: 'formatError'    
  };

  constructor() {}

  setFormValidator(field: any) {
    const validations: Validation[] = field.fieldInfo.validations;
    let validationList = [];
    if (validations.length) {
      validations.forEach((validation: Validation) => {
        if (this.validators[validation.key]) {
          if (Array.isArray(this.validators[validation.key])) {
            validationList.push(...this.validators[validation.key]);
          }
        }
      });
    }
    if (field.fieldInfo.minChar) {
      validationList.push(
        ...this.validators.PasswordMinLength(field.fieldInfo.minChar)
      );
    }
    if (field.fieldInfo.maxChar) {
      validationList.push(
        ...this.validators.PasswordMaxLength(field.fieldInfo.maxChar)
      );
    }
    return validationList;
  }

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  //Reset Password Validator
  validatePassword(controlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];

      if (control.errors && !control.errors.isValid) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      let passwordCheck = this.verifyPassword(control.value);
      if (passwordCheck && !passwordCheck.isvalid) {
        control.setErrors({
          isValid: true,
          message: passwordCheck.errorKey
        });
      } else {
        control.setErrors(null);
      }
    };
  }

  verifyPassword(password: string) {
    let response = {
      isvalid: true,
      errorKey: null
    };

    let upper = /[A-Z]/,
      lower = /[a-z]/,
      number = /[0-9]/,
      special = /[!#$%&*+?@~]/,
      email = 'abhishek.9.singh@coforge.com',
      username = 'Abhishek_9',
      count = 0;

    if (email == password) {
      response.isvalid = false;
      response.errorKey = this.errorMsg.email;
      return response;
    } else if (username == password) {
      response.isvalid = false;
      response.errorKey = this.errorMsg.userName;
      return response;
    }
    // Only need 2 out of 4 of these to match
    if (upper.test(password)) count++;
    if (lower.test(password)) count++;
    if (number.test(password)) count++;
    if (special.test(password)) count++;
    if (count < 2) {
      response.isvalid = false;
      response.errorKey = this.errorMsg.notMatch;
      return response;
    }

    return response;
  }

  //Existing Password Validator
  validateExistingPassword(controlName: string, userEmail: string, userName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];

      if (control.errors && !control.errors.isValid) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      let passwordCheck = this.verifyExistingPassword(control.value, userEmail, userName);
      if (passwordCheck && !passwordCheck.isvalid) {
        control.setErrors({
          isValid: true,
          message: passwordCheck.errorKey
        });
      } else {
        control.setErrors(null);
      }
    };
  }

  verifyExistingPassword(password: string, userEmail: string, userName: string) {
    let response = {
      isvalid: true,
      errorKey: null
    };

    let upper = /[A-Z]/,
      lower = /[a-z]/,
      number = /[0-9]/,
      special = /[!#$%&*+?@~]/,
      // email = 'abhishek.9.singh@coforge.com',
      // username = 'Abhishek_9',
      email = userEmail,
      username = userName,
      count = 0;

    if (email == password) {
      response.isvalid = false;
      response.errorKey = this.errorMsg.email;
      return response;
    } else if (username == password) {
      response.isvalid = false;
      response.errorKey = this.errorMsg.userName;
      return response;
    }
    // Only need 2 out of 4 of these to match
    if (upper.test(password)) count++;
    if (lower.test(password)) count++;
    if (number.test(password)) count++;
    if (special.test(password)) count++;
    if (count < 2) {
      response.isvalid = false;
      response.errorKey = this.errorMsg.notMatch;
      return response;
    }

    return response;
  }
}


